// @flow

import React from 'react';

type Props = {
  isSelectedRatio: boolean,
  changeSelectedRatio: () => void,
  ratioTitle: React.Fragment,
  ratioDescription: React.Fragment,
  ratioValue: string,
  ratioParenthesises: React.Fragment,
}

export default function GoodwillRatioButton(props: Props) {
  return (
    <div
      className={`impact-stores-description ${props.isSelectedRatio ? 'selected-ratio' : ''}`}
      onClick={props.changeSelectedRatio}
    >
      <div className="selected-ratio-shapes">
        <div className="left-triangle-container">
          <div className="left-triangle-container--up-triangle" />
          <div className="left-triangle-container--down-triangle" />
        </div>
        <div className="selected-ratio-shapes--rectangle" />
      </div>
      <div className="right-tab-line">
        <div className="right-tab-line--left-side">
          <span className="kpi-title">{props.ratioTitle}</span>
          <div className="kpi-description">
            {props.ratioDescription}
          </div>
        </div>
        <div className="impact-stores-values right-tab-line--right-side">
          <span>{props.ratioValue}</span>
          {props.ratioParenthesises}
        </div>
      </div>
    </div>
  );
}
